import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Modal from "../../../Components/UI/Modal/Modal";
import CloseButton from "../../../Components/UI/CloseButton/CloseButton";
import Spinner from "../../../Components/common/Spinner/Spinner";
import Field from "../../Settings/Content/Components/Field";

import { RequestNextHops, RequestSendTestEmail } from "../../../store/actions/mailGatewayActions";

import "./styles.scss";

const isSelected = (listItem, selectedNextHop) => {
  return listItem.domain === selectedNextHop?.domain && listItem.relay === selectedNextHop?.relay;
};

const SelectNextHopModal = ({ selectedHost, show, setShow }) => {
  const dispatch = useDispatch();

  const [selectedNextHop, setSelectedNextHop] = useState(null);
  const [targetAddress, setTargetAddress] = useState(null);

  const nextHops = useSelector((state) => state.mailGateway.mailTransferSettings.rcptDomains);
  const sendTestEmailLoading = useSelector((state) => state.mailGateway.sendTestEmailLoading);

  useEffect(() => {
    dispatch(RequestNextHops(selectedHost));
  }, [dispatch]);

  const handleTargetAddressChange = (e) => {
    const newTargetAddress = e.target.value;
    setTargetAddress(newTargetAddress);
    
    // Update selectedNextHop with target if it exists
    if (selectedNextHop) {
      setSelectedNextHop({
        ...selectedNextHop,
        target: newTargetAddress
      });
    }
  };

  const handleSendTestEmail = () => {
    if (sendTestEmailLoading || !selectedNextHop) return;
    
    // Ensure target is included in the selectedNextHop
    const nextHopWithTarget = {
      ...selectedNextHop,
      target: targetAddress
    };
    
    dispatch(RequestSendTestEmail({ 
      host: selectedHost, 
      reqBody: nextHopWithTarget
    }));
  };

  const handleContainerClick = (e) => {
    if (e.target === e.currentTarget) {
      setSelectedNextHop(null);
    }
  };

  return (
    <Modal active={show} setActive={setShow} type="select-nexthop">
      <div className="nexthop-container border" onClick={handleContainerClick}>
        <div className="nexthop-container__close">
          <CloseButton
            onClick={() => {
              setShow(false);
            }}
          />
        </div>
        <h3 className="nexthop-container__heading">Select Next Hop</h3>
        <div className="nexthop__list">
          {nextHops?.map((nextHop, i) => (
            <div
              className={`nexthop__item ${
                isSelected(nextHop, selectedNextHop) ? "nexthop__item--active" : ""
              } `}
              key={i}
              onClick={(e) => {
                e.stopPropagation();
                setSelectedNextHop(nextHop);
              }}>
              <span className="nexthop__item__point" />
              <p>{nextHop.domain}</p> - <p>{nextHop.relay}</p>
            </div>
          ))}
        </div>
        <div onClick={(e) => e.stopPropagation()}>
          <Field
            tooltipText={`Target Email address to test`}
            label="Target Email Address"
            width="220px"
            name="targetaddress"
            value={targetAddress || ''}
            onChange={handleTargetAddressChange} 
            type="text"
          />
        </div>
        <br/>
        <button
          disabled={!selectedNextHop || !targetAddress}
          className="products-body-form__file-button nexthop-container__button"
          onClick={handleSendTestEmail}>
          {sendTestEmailLoading ? <Spinner width={12} height={12} /> : "Send Test Email"}
        </button>
      </div>
    </Modal>
  );
};

export default SelectNextHopModal;